angular.module('gym.calendar').directive('eventRecurringBookings', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/calendar/events/edit_event_schedule/recurring_bookings.html.slim'),
    scope: {
      event: '=',
      bookings: '=',
      recurringBookings: '=',
      reloadEvent: '&',
      showAllBookingsAvailable: '&',
      showAllBookings: '&'
    },
    controller: ["$scope", "$rootScope", "$modal", "$q", "ContactBadgeService", "ReactModal", "EventService", function($scope, $rootScope, $modal, $q, ContactBadgeService, ReactModal, EventService) {
      var addBooking;
      $scope.getContactBadge = function(type, status) {
        return ContactBadgeService.get(type, status);
      };
      $scope.contactType = function(type) {
        return `${type.toLowerCase()}s`;
      };
      $scope.startTime = function(booking) {
        return moment(booking.recurring_bookings_start_at).format('h:mma, D MMM YYYY');
      };
      addBooking = function(contact) {
        var deferred;
        deferred = $q.defer();
        EventService.addSingleBooking(contact, $scope.event, $scope.bookings, deferred);
        return deferred.promise;
      };
      $scope.bookNow = function(booking) {
        return EventService.getContactForBooking(booking.contact_name, booking.contact_id, $scope.event.id).then(function(contact) {
          return addBooking(contact).then(function() {
            return $scope.reloadEvent();
          });
        });
      };
      return $scope.disableRecurringBookings = function(booking) {
        var modalInstance;
        modalInstance = ReactModal.open({
          component: 'DisableRecurringBookingsModal',
          props: {
            booking: null,
            event: $scope.event.plain(),
            recurringBooking: booking
          }
        });
        return modalInstance.then(function() {
          return $scope.reloadEvent();
        });
      };
    }]
  };
});
